// 20.1.2.5 Number.isSafeInteger(number)
var $export = require('./_export');
var isInteger = require('./_is-integer');
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.number.is-safe-integer.js
// module id = A1ng
// module chunks = 1